import { render, staticRenderFns } from "./ShemaCommandCell.vue?vue&type=template&id=2f8b6c31&"
import script from "./ShemaCommandCell.vue?vue&type=script&lang=js&"
export * from "./ShemaCommandCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports